import {
    REFEREE_PATCH_FAILURE,
    REFEREE_PATCH_REQUEST,
    REFEREE_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, referee} = action;
    switch (type) {
        case REFEREE_PATCH_SUCCESS: {return {
            ...initialState,
            referee,
        }}

        case REFEREE_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case REFEREE_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
